import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const APP_URL = process.env.REACT_APP_APP_URL;
const API_BASE = process.env.REACT_APP_API_BASE_URL;

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [email, setEmail] = useState(params.get('email') || '');
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setInfo('');
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE}/auth/verify-email`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, code }),
      });
      const data = await res.json();

      if (res.ok && data.success) {
        window.location.href = `${APP_URL}/dashboard`;
      } else {
        setError(data.error || 'Ошибка подтверждения');
      }
    } catch (err) {
      setError('Ошибка сети');
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    setError('');
    setInfo('');
    try {
      const res = await fetch(`${API_BASE}/auth/resend-code`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (res.ok) setInfo('Код отправлен повторно. Проверьте почту.');
      else setError('Не удалось отправить код');
    } catch {
      setError('Ошибка сети');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-md p-8 max-w-md w-full">
        <h1 className="text-2xl font-bold text-center mb-2">Подтверждение email</h1>
        <p className="text-sm text-gray-500 text-center mb-6">
          Мы отправили 6-значный код на <b>{email}</b>
        </p>

        {error && <div className="bg-red-50 text-red-500 p-3 rounded-xl mb-4">{error}</div>}
        {info && <div className="bg-green-50 text-green-700 p-3 rounded-xl mb-4">{info}</div>}

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            required
            maxLength={6}
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
            className="w-full border rounded-xl px-4 py-3 text-center text-2xl tracking-[8px] focus:ring-2 focus:ring-blue-400 focus:outline-none"
            placeholder="000000"
          />

          <button
            type="submit"
            disabled={loading || code.length !== 6}
            className={`w-full py-3 rounded-xl text-white transition ${
              loading || code.length !== 6 ? 'bg-blue-300 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'
            }`}
          >
            {loading ? 'Проверка...' : 'Подтвердить'}
          </button>
        </form>

        <button
          onClick={handleResend}
          className="w-full mt-4 py-2 text-sm text-blue-600 hover:underline"
        >
          Отправить код повторно
        </button>
      </div>
    </div>
  );
}